/* eslint-disable no-console */
enum MessagePrefix {
  accessibility = 'Flora Accessibility',
  development = 'Flora Development',
}

interface FloraMessageParams {
  type: 'log' | 'exception'
  category: 'accessibility' | 'development'
  status?: 'error' | 'warn' | 'info'
  message: string
}

const log = ({ category, status = 'info', message }: Omit<FloraMessageParams, 'type'>) => {
  console[status](`${MessagePrefix[category]} (${[status]}): ${message}`)
}

const exception = ({ category, message }: Omit<FloraMessageParams, 'type' | 'status'>) => {
  throw new Error(`${MessagePrefix[category]} (error): ${message}`)
}

export const floraMessage = ({ category, type, status, message }: FloraMessageParams) => {
  if (type === 'log') {
    log({ category, status, message })
  }

  if (type === 'exception') {
    exception({ category, message })
  }
}
